import { ENotAuthNavigation } from '@hts/shared/enums';
import { useIsMobile } from '@hts/shared/libs';
import { HtsTypography, HtslIcon } from '@hts/shared/ui';
import { memo } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';
import styles from '../styles/CategoryGalleryItem.module.scss';

interface ICategoryGalleryItemProps {
  name: string;
  src: string;
  cardId: number;
  slug: string;
}

export const CategoryGalleryItem: React.FC<ICategoryGalleryItemProps> = memo(
  ({ name, src, cardId, slug }) => {
    const isMobile = useIsMobile();

    const linkTo = `${ENotAuthNavigation.CATEGORY_OF_CARD}/${slug}`;

    return (
      <div className={styles.centerContainer}>
        <div className={styles.container}>
          <Link to={linkTo} className={styles.imageLink}>
            <LazyLoadImage
              src={src}
              alt={name}
              effect="blur"
              wrapperClassName={styles.imageWrapper}
            />
          </Link>

          <Link to={linkTo} className={styles.link}>
            <HtsTypography variant={isMobile ? 'body2' : 'body1'}>{name}</HtsTypography>

            <HtslIcon icon="arrow-right" />
          </Link>
        </div>
      </div>
    );
  }
);
